<template>
    <div class="result-audit">
        <!-- 页面标题 -->
        <div class="page-header">
            <h2 class="page-title">中标结果公告审核</h2>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">公告名称:</label>
                <el-input v-model="searchForm.winBulletinName" placeholder="请输入公告名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
            <div class="status-tabs">
                <el-radio-group v-model="searchForm.status" @change="handleStatusChange">
                    <el-radio-button :label="1">待审核</el-radio-button>
                    <el-radio-button :label="9">已审核</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="winBulletinName" label="中标结果公告标题" show-overflow-tooltip />
                <el-table-column prop="winBulletinCode" label="中标结果公告编号" align="center" />
                <el-table-column prop="bidSectionName" label="标段名称" align="center" />
                <el-table-column prop="publicTime" label="发布时间" align="center" />
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewStatus(scope.row)" class="action-btn" v-if="searchForm.status==1">
                            审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
        <!-- 审核弹窗 -->
        <el-dialog title="审核" :visible.sync="auditDialogVisible" width="500px" :close-on-click-modal="false"
            :append-to-body="true">
            <el-form :model="auditForm" label-width="100px">
                <el-form-item label="审核意见:">
                    <el-input v-model="auditForm.auditOpinion" type="textarea" :rows="4" placeholder="请输入审核意见" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="auditDialogVisible = false">取消</el-button>
                <el-button type="warning" @click="handleAudit(2)">退回</el-button>
                <el-button type="primary" @click="handleAudit(9)">通过</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { AuditwinBulletinDetail, AuditwinBulletinCheck, AuditwinBulletinList } from '@/api/winBulletin/api'
export default {

    data() {
        return {
            loading: false,
            searchForm: {
                winBulletinName: '',
                status: 1 // 1：待审核、9：已审核
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            auditDialogVisible: false,
            auditForm: {
                auditOpinion: '',
                winBulletinCode: '',
                tenderNoticeCode: ''
            },
            currentRow: null
        }
    },
    mounted() {
        this.AuditwinBulletinList()
    },
    methods: {
        // 获取数据
        AuditwinBulletinList() {
            this.loading = true
            AuditwinBulletinList({
                winBulletinName: this.searchForm.winBulletinName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                status: this.searchForm.status
            }).then(res => {
                this.loading = false
                if (res.code == 200) {
                    this.tableData = res.data.records
                    this.pagination.total = res.data.total
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.loading = false
                this.$message.error('获取数据失败')
            })
        },

        // 状态切换
        handleStatusChange() {
            this.pagination.currentPage = 1
            this.AuditwinBulletinList()
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.AuditwinBulletinList()
        },

        // 查看详情
        handleViewDetails(row) {
            this.AuditwinBulletinDetail(row.winBulletinCode)
        },
        // 详情数据
        AuditwinBulletinDetail(winBulletinCode) {
            AuditwinBulletinDetail({
                winBulletinCode: winBulletinCode
            }).then(res => {
                if (res.code == 200) {
                    this.$router.push({ path: '/agentHome/addBidNotice', query: { projectCode: res.data.projectCode, winBulletinCode: winBulletinCode } })
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 查看状态 - 打开审核弹窗
        handleViewStatus(row) {
            this.currentRow = row
            this.auditForm.tenderNoticeCode = row.winBulletinCode 
            this.auditForm.auditOpinion = ''
            this.auditDialogVisible = true
        },

        // 审核操作
        handleAudit(status) {
            if (!this.auditForm.auditOpinion && status === 2) {
                this.$message.warning('退回时请填写审核意见')
                return
            }
            const params = {
                tenderNoticeCode: this.auditForm.tenderNoticeCode,
                auditOpinion: this.auditForm.auditOpinion,
                status: status // 2：退回、9：通过
            }
            AuditwinBulletinCheck(params).then(res => {
                if (res.code == 200) {
                    this.$message.success(status === 2 ? '退回成功' : '审核通过')
                    this.auditDialogVisible = false
                    this.AuditwinBulletinList()
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.$message.error('审核操作失败')
            })
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.AuditwinBulletinList()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.AuditwinBulletinList()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(result-audit);

.page-header {
    .warning-text {
        margin-left: 10px;
        color: #F56C6C;
        font-size: 14px;
        font-weight: 500;
    }
}

.search-section {
    .status-tabs {
        margin-top: 15px;
    }
}
</style>
